// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main2 {
    width: 500px;
    padding: 5px;
    border: 1px solid black; /* Safari */
    display: flex;
}
.main {
    min-width: 800px;
    overflow-y: auto;
    max-height: 400px;
    min-height: 400px;
    padding-right: 5px;
}
.main2 div {  /* Safari 6.1+ */  /* IE 10 */
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /*margin: 10px;*/
}
/*.file-avatar {*/
    /*flex: 0.2 !important;*/
/*}*/
.error {
    font-size: 13px;
    color: #d32f2f;
}
.doclist-wrapper {
    margin-right: 2em;
}
.doc-header {
    background-color: #fff;
    height: 9px;
    border-bottom: 1px solid #eaeaea;
    margin-right: 2em;
    position: fixed;
    transition: border-color .2s, box-shadow .2s;
    z-index: 5;
}
.doc-header.shadow {
    border-color: #eaeaea;
    box-shadow: 0 4px 6px -2px rgba(0,0,0,.04);
}
.doclist {
    list-style: none;
    margin: 9px 0 0;
    padding: 0;
}
.doclist li {
    align-items: center;
    border-top: 1px solid transparent;
    border-bottom: 1px solid #eaeaea;
    margin-top: -1px;
}
.doclist li.selected {
    background-color: rgba(0,178,201,0.05);
    border-color: rgba(0,150,178,0.2);
}
.file-avatar-icon img {
    display: block;
    width: 32px;
    height: 32px;
    object-fit: contain;
    border-radius: 50%;
}
.file-avatar-icon img.cover {
    object-fit: cover;
}
.file-avatar img {
    display: block;
    margin: 10px;
    width: 32px;
    height: 32px;
    object-fit: contain;
    border-radius: 50%;
}
.file-avatar img.cover {
    object-fit: cover;
}
.file-filename {
    padding: 6px 0;
    max-width: 50%;
}
.file-filename a {
    cursor: pointer;
}
.file-username {
    display: inline-flex;
    /*max-width: 100%;*/
    max-width: 50%;
}
.file-username a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.selected .file-username a, .selected .file-username span {
    color: #1a5976;
}
.file-version {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 2px;
    font-size: 12px;
    margin-left: 5px;
    padding: 1px 4px;
}
.file-share, .file-restore, .file-delete {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    cursor: pointer;
    display: none;
    line-height: 22px;
    outline: none;
    position: relative;
    margin-left: 10px;
    min-width: 40px;
    padding: 0 10px;
    text-align: center;
}
.file-share { padding: 0 16px; }
.file-delete { margin-right: 10px; }
.doclist li:hover .file-share, .doclist li:hover .file-restore, .doclist li:hover .file-delete {
    display: block;
}
.file-action {
    color: #aaa;
    width: 40px;
    height: 40px;
}
.doclist li:hover .file-action {
    color: inherit;
}
.file-desc, .file-name {
    color: #999;
    font-size: 13px;
}
.file-name {
    margin-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.mat-select {
    margin: 10px;
}
.mat-input-element {
    width: 345px;
}
.mat-mini-fab {
    color: white;
    margin: 5px;
    font-size: 16px;
    background-color: rgba(0, 188, 212, 0.46);
}

.mat-icon {
    font-size: 20px;
}
.mat-divider {
    background-color: cornflowerblue;
}
.owner {
    display: flex;
    align-items: center;
    height: 30px;
    min-width: 100px;
    margin: 10px
}
.live-search {
    background-color: #fff;
    box-sizing: border-box;
    box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);
    margin-top: 5px;
    position: absolute;
    width: 345px;
    z-index: 10;
}
.live-search ul {
    list-style: none;
    margin: 0;
    padding: 0;
}
.live-search a {
    cursor: pointer;
    padding: 10px;
}
.live-search a:hover {
    background-color: #f4f5f7;
    text-decoration: none;
}
.live-search img {
    margin-right: 10px;
    object-fit: cover;
    min-width: 32px;
    width: 32px;
    height: 32px;
}
.live-search .name, .live-search .desc {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.live-search .desc {
    color: #999;
    font-size: 12px;
}
.live-search .not-found {
    padding: 10px 20px;
}
.mat-select {
    width: 100px;
}
button i {
    font-size: 16px;
    margin-right: 10px;
}

.menu button {
    padding: 0 12px;
    margin-left: 10px;
 }
 
 .menu button.mat-primary {
    line-height: 30px;
 }
 
 .menu button:not(.mat-primary) {
    border: 1px solid #bdc3c7;
    line-height: 28px;
 }
 
 .menu button i {
    font-size: 16px;
    margin-right: 10px;
 }

.label-group {
   margin-left: 1em;
   padding: 3px 4px;
   width: 40px;
   font-size: 80%;
   display: inline-block;
   border: 1px solid #eaeaea;
   background-color: #dff0d8;
   border-radius: 5px;
}

.label-group-blank {
   margin-left: 1em;
   padding: 3px 4px;
   width: 40px;
   display: inline-block;
   border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/corporate-member/member.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB,EACA,WAAW;IAClC,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;AACA,cACsB,gBAAgB,GACpB,UAAU;IACxB,OAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA,iBAAiB;IACb,wBAAwB;AAC5B,IAAI;AACJ;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,4CAA4C;IAC5C,UAAU;AACd;AACA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,gCAAgC;IAChC,gBAAgB;AACpB;AACA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;AACA,cAAc,eAAe,EAAE;AAC/B,eAAe,kBAAkB,EAAE;AACnC;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,eAAe;AACnB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB;AACJ;AACA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,2CAA2C;IAC3C,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;CACpB;;CAEA;IACG,iBAAiB;CACpB;;CAEA;IACG,yBAAyB;IACzB,iBAAiB;CACpB;;CAEA;IACG,eAAe;IACf,kBAAkB;CACrB;;AAED;GACG,gBAAgB;GAChB,gBAAgB;GAChB,WAAW;GACX,cAAc;GACd,qBAAqB;GACrB,yBAAyB;GACzB,yBAAyB;GACzB,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;GAChB,WAAW;GACX,qBAAqB;GACrB,kBAAkB;AACrB","sourcesContent":[".main2 {\n    width: 500px;\n    padding: 5px;\n    border: 1px solid black;\n    display: -webkit-flex; /* Safari */\n    display: flex;\n}\n.main {\n    min-width: 800px;\n    overflow-y: auto;\n    max-height: 400px;\n    min-height: 400px;\n    padding-right: 5px;\n}\n.main2 div {\n    -webkit-flex: 1;  /* Safari 6.1+ */\n    -ms-flex: 1;  /* IE 10 */\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    /*margin: 10px;*/\n}\n/*.file-avatar {*/\n    /*flex: 0.2 !important;*/\n/*}*/\n.error {\n    font-size: 13px;\n    color: #d32f2f;\n}\n.doclist-wrapper {\n    margin-right: 2em;\n}\n.doc-header {\n    background-color: #fff;\n    height: 9px;\n    border-bottom: 1px solid #eaeaea;\n    margin-right: 2em;\n    position: fixed;\n    transition: border-color .2s, box-shadow .2s;\n    z-index: 5;\n}\n.doc-header.shadow {\n    border-color: #eaeaea;\n    box-shadow: 0 4px 6px -2px rgba(0,0,0,.04);\n}\n.doclist {\n    list-style: none;\n    margin: 9px 0 0;\n    padding: 0;\n}\n.doclist li {\n    align-items: center;\n    border-top: 1px solid transparent;\n    border-bottom: 1px solid #eaeaea;\n    margin-top: -1px;\n}\n.doclist li.selected {\n    background-color: rgba(0,178,201,0.05);\n    border-color: rgba(0,150,178,0.2);\n}\n.file-avatar-icon img {\n    display: block;\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n    border-radius: 50%;\n}\n.file-avatar-icon img.cover {\n    object-fit: cover;\n}\n.file-avatar img {\n    display: block;\n    margin: 10px;\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n    border-radius: 50%;\n}\n.file-avatar img.cover {\n    object-fit: cover;\n}\n.file-filename {\n    padding: 6px 0;\n    max-width: 50%;\n}\n.file-filename a {\n    cursor: pointer;\n}\n.file-username {\n    display: inline-flex;\n    /*max-width: 100%;*/\n    max-width: 50%;\n}\n.file-username a {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.selected .file-username a, .selected .file-username span {\n    color: #1a5976;\n}\n.file-version {\n    background: #fff;\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    font-size: 12px;\n    margin-left: 5px;\n    padding: 1px 4px;\n}\n.file-share, .file-restore, .file-delete {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    cursor: pointer;\n    display: none;\n    line-height: 22px;\n    outline: none;\n    position: relative;\n    margin-left: 10px;\n    min-width: 40px;\n    padding: 0 10px;\n    text-align: center;\n}\n.file-share { padding: 0 16px; }\n.file-delete { margin-right: 10px; }\n.doclist li:hover .file-share, .doclist li:hover .file-restore, .doclist li:hover .file-delete {\n    display: block;\n}\n.file-action {\n    color: #aaa;\n    width: 40px;\n    height: 40px;\n}\n.doclist li:hover .file-action {\n    color: inherit;\n}\n.file-desc, .file-name {\n    color: #999;\n    font-size: 13px;\n}\n.file-name {\n    margin-top: 4px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.mat-select {\n    margin: 10px;\n}\n.mat-input-element {\n    width: 345px;\n}\n.mat-mini-fab {\n    color: white;\n    margin: 5px;\n    font-size: 16px;\n    background-color: rgba(0, 188, 212, 0.46);\n}\n\n.mat-icon {\n    font-size: 20px;\n}\n.mat-divider {\n    background-color: cornflowerblue;\n}\n.owner {\n    display: flex;\n    align-items: center;\n    height: 30px;\n    min-width: 100px;\n    margin: 10px\n}\n.live-search {\n    background-color: #fff;\n    box-sizing: border-box;\n    box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);\n    margin-top: 5px;\n    position: absolute;\n    width: 345px;\n    z-index: 10;\n}\n.live-search ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.live-search a {\n    cursor: pointer;\n    padding: 10px;\n}\n.live-search a:hover {\n    background-color: #f4f5f7;\n    text-decoration: none;\n}\n.live-search img {\n    margin-right: 10px;\n    object-fit: cover;\n    min-width: 32px;\n    width: 32px;\n    height: 32px;\n}\n.live-search .name, .live-search .desc {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.live-search .desc {\n    color: #999;\n    font-size: 12px;\n}\n.live-search .not-found {\n    padding: 10px 20px;\n}\n.mat-select {\n    width: 100px;\n}\nbutton i {\n    font-size: 16px;\n    margin-right: 10px;\n}\n\n.menu button {\n    padding: 0 12px;\n    margin-left: 10px;\n }\n \n .menu button.mat-primary {\n    line-height: 30px;\n }\n \n .menu button:not(.mat-primary) {\n    border: 1px solid #bdc3c7;\n    line-height: 28px;\n }\n \n .menu button i {\n    font-size: 16px;\n    margin-right: 10px;\n }\n\n.label-group {\n   margin-left: 1em;\n   padding: 3px 4px;\n   width: 40px;\n   font-size: 80%;\n   display: inline-block;\n   border: 1px solid #eaeaea;\n   background-color: #dff0d8;\n   border-radius: 5px;\n}\n\n.label-group-blank {\n   margin-left: 1em;\n   padding: 3px 4px;\n   width: 40px;\n   display: inline-block;\n   border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
